function formatCardData(cardData) {
  if (cardData && cardData?.expiry && cardData?.cardNumber && cardData?.cvc) {
    let tempExpiry = cardData?.expiry;
    tempExpiry = tempExpiry.replace(/\s/g, '');
    const expiryArray = tempExpiry.split('/'); // ["04", "2026"]
    const month = expiryArray[0]; // "04"
    const year = expiryArray[1]; // "2026"
    let tempCardNumber = cardData?.cardNumber;
    tempCardNumber = tempCardNumber.replace(/\D/g, '');
    const data = {
      cardNumber: tempCardNumber,
      month,
      year,
      cardCode: cardData?.cvc,
    };
    return data;
  }
  return {};
}

function responseHandler(response, callback) {
  if (response?.messages?.resultCode === 'Error') {
    const errorMessage = response.messages.message
      .map((msg) => `${msg.code} : ${msg.text}`)
      .join('\n, ');
    callback(null, { message: errorMessage });
  } else {
    callback(response.opaqueData, null);
  }
}

export function tokenizeCardData(data, callback) {
  const authData = {
    clientKey: `${process.env.REACT_APP_CLIENT_KEY}`,
    apiLoginID: `${process.env.REACT_APP_API_LOGIN_KEY}`,
  };
  const cardData = formatCardData(data);
  if (
    window?.acceptLoaded &&
    typeof window?.Accept?.dispatchData === 'function'
  ) {
    window.Accept.dispatchData(
      {
        cardData,
        authData,
      },
      (response) => responseHandler(response, callback)
    );
  } else {
    callback(null, {
      message:
        'Payment system is not ready yet. Please try again in a few seconds.',
    });
  }
}
